import { isCustomContentId } from "@@/shared/pages/content/custom-content/custom-content-id";
import type {
    ProductId} from "@@/shared/products/product-id";
import {
    isProductId,
    productIdZodSchema,
} from "@@/shared/products/product-id";
import { z } from "zod";
import type { PageId} from "../page-id";
import { isPageId, pageIdZodSchema } from "../page-id";
import type {
    CustomContentId} from "./custom-content/custom-content-id";
import {
    customContentIdZodSchema,
} from "./custom-content/custom-content-id";

type ContentId = PageId | ProductId | CustomContentId;
const contentIdZodSchema = z.union([
    pageIdZodSchema,
    productIdZodSchema,
    customContentIdZodSchema,
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isContentId = (value: any): value is ContentId => {
    return isPageId(value) || isProductId(value) || isCustomContentId(value);
};

export { contentIdZodSchema, isContentId };
export type { ContentId };
